import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useStore } from "@/lib/store";
import { ProductCard } from "@/components/ProductCard";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { user, wishlist } = useStore();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    api.get("/wishlist").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, [user, wishlist.length]);

  if (!user) {
    return (
      <div className="max-w-3xl mx-auto py-24 px-6 text-center">
        <div className="eyebrow">Your Saved Pieces</div>
        <div className="font-serif-luxe text-3xl mt-3 text-[#FAF8F5]">Sign in to view your wishlist</div>
        <Link to="/auth" className="btn-gold mt-8 inline-flex">Sign In</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="wishlist-page">
      <div className="text-center mb-12">
        <div className="eyebrow">Saved For You</div>
        <h1 className="font-serif-luxe text-4xl sm:text-5xl text-[#FAF8F5] mt-3">My Wishlist</h1>
      </div>
      {loading ? (
        <div className="text-center py-24 text-[#C2B29F]">Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-24">
          <div className="text-[#C2B29F] mb-6">You haven't saved anything yet.</div>
          <Link to="/shop" className="btn-outline-gold">Discover Jewellery</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i}/>)}
        </div>
      )}
    </div>
  );
}
